import React from 'react';
import './Footer.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* Top bar — logo + tagline */}
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo-wrapper">
              <img
                src="/avtech-logo.jpeg"
                alt="AVTECH Logo"
                className="footer-logo-img"
              />
              <h3 className="footer-logo">
                AVTECH<span className="footer-logo-dot">.</span>
              </h3>
            </div>
            <p className="footer-description">
              An independent tech studio building calm, resilient
              software for ambitious teams — and training the engineers
              who will build what's next.
            </p>
          </div>

          <div className="footer-cta">
            <span className="footer-cta-label">// Start a project</span>
            <a href="mailto:avtechbmt@gmail.com" className="footer-cta-link">
             avtechbmt@gmail.com
              <span className="footer-cta-arrow">→</span>
            </a>
          </div>
        </div>

        {/* Link columns */}
        <div className="footer-grid">
          <div className="footer-column">
            <h4 className="footer-column-title">Products</h4>
            <ul className="footer-links">
              <li><a href="#products">SaaS Boilerplate Pro</a></li>
              <li><a href="#products">Offline-First Retail Suite</a></li>
              <li><a href="#services">Custom Solutions</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-column-title">Academy</h4>
            <ul className="footer-links">
              <li><a href="#academy">Cohort Program</a></li>
              <li><a href="#academy">Curriculum</a></li>
              <li><a href="#academy">Mentorship</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-column-title">Company</h4>
            <ul className="footer-links">
              <li><a href="#genesis">About</a></li>
              <li><a href="#contact">Contact</a></li>
              <li><a href="#">Careers</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-column-title">Connect</h4>
            <ul className="footer-links footer-social-list">
              <li><a href="#">GitHub ↗</a></li>
              <li><a href="#">Twitter ↗</a></li>
              <li><a href="#">LinkedIn ↗</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <span className="footer-copyright">
            © {currentYear} AVTECH Studio. All rights reserved.
          </span>
          <div className="footer-legal">
            <a href="#">Privacy Policy</a>
            <span className="footer-divider">·</span>
            <a href="#">Terms of Service</a>
          </div>
          <span className="footer-meta">EST. 2024 · SF · LISBON</span>
        </div>
      </div>
    </footer>
  );
}